<template>
    <slot />
</template>

<style lang="scss">
    @use "tippy.js/dist/tippy.css";
    @use "@/sass/partials/variables" as legacyVariables;
    @use "@/sass/design-system/variables" as variables;

    .tippy-box-base-styles {
        border: 1px solid variables.$gray300;
        border-radius: 16px;
        background-color: variables.$baseWhite;
        box-shadow: 0 1px 2px rgba(legacyVariables.$ship-cove, 0.12), 0 8px 32px rgba(legacyVariables.$ship-cove, 0.24);
        color: legacyVariables.$pill-color;
        font-size: 12px;
        font-weight: 500;

        // needed because global styles overwrite tippy styles
        *:not(a) {
            color: legacyVariables.$pill-color;
        }

        .tippy-content {
            padding: 6px !important;
        }
    }

    .tippy-dark-box-base-styles {
        border: 1px solid legacyVariables.$lavender;
        background-color: legacyVariables.$tooltip-background;
        color: variables.$baseWhite;

        * {
            color: variables.$baseWhite;
        }

        .tippy-arrow {
            color: legacyVariables.$tooltip-background;
        }

        .tippy-content {
            padding: 6px !important;
        }
    }

    .tippy-box[data-theme~="base"] {
        @extend .tippy-box-base-styles;
    }

    .tippy-box[data-theme~="default-dark"],
    .tippy-box[data-theme~="default"] {
        @extend .tippy-box-base-styles;
        padding: 8px;
        box-shadow: 0 1px 2px rgba(legacyVariables.$ship-cove, 0.12), 0 8px 32px rgba(legacyVariables.$ship-cove, 0.24);
    }

    .tippy-box[data-theme~="default-dark"] {
        @extend .tippy-dark-box-base-styles;
    }

    .tippy-box[data-theme~="base-light"] {
        @extend .tippy-box-base-styles;

        *:not(a) {
            color: variables.$baseBlack;
        }

        .tippy-arrow {
            color: variables.$baseWhite;
        }
    }

    .tippy-box[data-theme~="base-dark"] {
        @extend .tippy-box-base-styles;
        @extend .tippy-dark-box-base-styles;
    }

    .dark-theme {
        .tippy-box[data-theme~="base"] {
            @extend .tippy-dark-box-base-styles;
        }

        .tippy-box[data-theme~="default"] {
            @extend .tippy-dark-box-base-styles;
            box-shadow: none;
        }
    }

    // only dark themed style, with no content paddings
    .tippy-box[data-theme~="base-dark"] {
        @extend .tippy-dark-box-base-styles;
        overflow: hidden;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 500;
    }

    // Transparent Tippy theme without background and arrow
    .tippy-box[data-theme~="transparent"] {
        border: none;
        background-color: transparent;
        box-shadow: none;

        .tippy-arrow {
            display: none;
        }
    }

    .tippy-box[data-theme~="builder"] {
        padding: 4px;
        border: 1px solid variables.$blue900;
        border-radius: 12px;
        background-color: variables.$blue950;
        box-shadow: 0 0 24px 0 rgba(36, 1, 60, 0.35);
        color: variables.$gray50;
        font-size: 12px;

        .tippy-arrow {
            color: variables.$blue950;
        }
    }
</style>
